<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="store.waybills">
        <template v-slot:title>
          <span>{{ $t("waybills.self") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.transaction_type')">
                <multiple-select-input
                    v-if="transactionTypes"
                    :model.sync="form.transaction_type"
                    :multiple="false"
                    :values="transactionTypes"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('transaction_type') && !$v.form.transaction_type.required"
                    :state="validateState('transaction_type') && $v.form.transaction_type.required">
                  {{ $t('waybills.validations.transaction_type.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.waybill_date')">
                <b-form-input
                    v-model="form.waybill_date"
                    :placeholder="$t('waybills.waybill_date')"
                    :state="validateState('waybill_date')"
                    class="form-control form-control-solid"
                    name="name"
                    type="date"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('waybill_date') && !$v.form.waybill_date.required"
                    :state="validateState('waybill_date') && $v.form.waybill_date.required">
                  {{ $t('waybills.validations.waybill_date.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.document_number')">
                <b-form-input
                    v-model="form.document_number"
                    :placeholder="$t('waybills.document_number')"
                    :state="validateState('document_number')"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState('document_number') && !$v.form.document_number.required"
                    :state="validateState('document_number') && $v.form.document_number.required">
                  {{ $t('waybills.validations.document_number.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>


            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.technician')">
                <multiple-select-input
                    v-if="technicians"
                    :model.sync="form.technician_id"
                    :multiple="false"
                    :disabled="form.institution_id || form.branch_id"
                    :values="technicians"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('technician_id') && !$v.form.technician_id.required"
                    :state="validateState('technician_id') && $v.form.technician_id.required">
                  {{ $t('waybills.validations.technician.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.institution')">
                <multiple-select-input
                    v-if="institutions"
                    :model.sync="form.institution_id"
                    :disabled="form.technician_id"
                    :multiple="false"
                    :values="institutions"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('institution_id') && !$v.form.institution_id.required"
                    :state="validateState('institution_id') && $v.form.institution_id.required">
                  {{ $t('waybills.validations.institution.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.branch')">
                <multiple-select-input
                    v-if="branches"
                    :model.sync="form.branch_id"
                    :disabled="form.technician_id"
                    :multiple="false"
                    :values="branches"
                    label="name"
                    track-by="id"
                ></multiple-select-input>
                <b-form-invalid-feedback
                    v-if="!validateState('branch_id') && !$v.form.branch_id.required"
                    :state="validateState('branch_id') && $v.form.branch_id.required">
                  {{ $t('waybills.validations.branch.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('waybills.description')">
                <b-form-input
                    v-model="form.description"
                    :placeholder="$t('waybills.description')"
                    class="form-control form-control-solid"
                    name="description"
                    type="text"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <div class="form-group">
                <label>{{ $t('waybills.file') }} </label>
                <div class="custom-file">
                  <input type="file"
                         accept="image/*"
                         ref="material-image"
                         @change="uploadFile($event)"
                         :placeholder="$t('general.select')"
                         class="custom-file-input" id="inputGroupFile02">
                  <label class="custom-file-label" for="inputGroupFile02">{{ $t('general.select_option')}}</label>
                </div>
              </div>
            </b-col>

            <b-col lg="12" md="12" sm="12" xl="12">
              <div class="d-flex justify-content-between mb-3">
                 <span class="h4">
                   {{ $t('waybills.materials') }}
                 </span>
                <b-button variant="warning" @click="addTransaction">
                  <i class="fa fa-plus"></i>
                </b-button>
              </div>
            </b-col>

            <template v-for="(transaction, index) in form.transactions">
              <b-col lg="4" md="4" sm="12" xl="4">
                <b-form-group :label="$t('waybills.materials')">
                  <multiple-select-input
                      v-if="materials"
                      :model.sync="transaction.material_id"
                      :multiple="false"
                      :values="materials"
                      label="name"
                      track-by="id"
                      @onSelect="onMaterialSelect($event, index)"
                  ></multiple-select-input>
                  <b-form-invalid-feedback
                      v-if="!validateState('material_id', index) && !$v.form.transactions.$each[index].material_id.required"
                      :state="validateState('material_id', index) && $v.form.transactions.$each[index].material_id.required">
                    {{ $t('waybills.validations.material.required') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="4" md="4" sm="12" xl="4">
                <b-form-group :label="$t('materials.amount')">
                  <b-form-input
                      v-model="transaction.net_amount"
                      :placeholder="$t('materials.amount')"
                      :state="validateState('net_amount', index)"
                      class="form-control form-control-solid"
                      name="amount"
                      :max="transaction.max_amount || 0"
                      type="number"
                  ></b-form-input>
                  <b-form-invalid-feedback
                      v-if="!validateState('net_amount', index) && !$v.form.transactions.$each[index].net_amount.required"
                      :state="true">
                    {{ $t('materials.validations.amount.required') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

              <b-col lg="4" md="4" sm="12" xl="4">
                <b-form-group :label="$t('waybills.unit')">
                  <multiple-select-input
                      v-if="units"
                      :model.sync="transaction.unit_id"
                      :multiple="false"
                      :values="units"
                      label="code"
                      track-by="id"
                  ></multiple-select-input>
                  <b-form-invalid-feedback
                      v-if="!validateState('unit_id', index) && !$v.form.transactions.$each[index].unit_id.required"
                      :state="validateState('unit_id', index) && $v.form.transactions.$each[index].unit_id.required">
                    {{ $t('waybills.validations.unit.required') }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>

            </template>

            <template v-if="form.id && form.exits_file">
              <b-col lg="3" md="3" sm="12" xl="3">
                <img :src="form.exits_file" class="img-fluid img-thumbnail">
                <div class="text-center">
                  <b-btn class="mt-2" size="xs" variant="danger" @click="deleteFile()"><i class="fa fa-trash"></i>
                  </b-btn>
                </div>
              </b-col>
            </template>

            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  DELETE_FILE,
  ERROR,
  FILES,
  GET_FILES,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM,
  UPLOAD_FILE
} from "@/core/services/store/waybill.module";

import unitModule, {
  GET_ALL_ITEMS as GET_UNIT_ITEMS,
  ITEMS_ALL as UNIT_ITEMS,
  MODULE_NAME as UNIT_MODULE
} from "@/core/services/store/unit.module";

import materialModule, {
  ITEMS_ALL as MATERIAL_ITEMS,
  MODULE_NAME as MATERIAL_MODULE,
  GET_ALL_ITEMS as GET_MATERIAL_ITEMS
} from "@/core/services/store/material.module";

import branchModule, {
  ITEMS_ALL as BRANCH_ITEMS,
  MODULE_NAME as BRANCH_MODULE,
  GET_ALL_ITEMS as GET_BRANCH_ITEMS
} from "@/core/services/store/branch.module";

import institutionModule, {
  ITEMS_ALL as INSTITUTION_ITEMS,
  MODULE_NAME as INSTITUTION_MODULE,
  GET_ALL_ITEMS as GET_INSTITUTION_ITEMS
} from "@/core/services/store/institution.module";

import userModule, {
  TECHNICIANS,
  MODULE_NAME as USER_MODULE,
  GET_TECHNICIANS
} from "@/core/services/store/user.module";

import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required, requiredIf} from "vuelidate/lib/validators";
import MultipleSelectInput from "@/assets/components/inputs/MultipleSelectInput";
import _ from "lodash";

const _MODULE_NAME = MODULE_NAME;
const _UNIT_MODULE = UNIT_MODULE;
const _MATERIAL_MODULE = MATERIAL_MODULE;
const _INSTITUTION_MODULE = INSTITUTION_MODULE;
const _BRANCH_MODULE = BRANCH_MODULE;
const _USER_MODULE = USER_MODULE;

export default {
  name: "MaterialsCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
    registerStoreModule(_UNIT_MODULE, unitModule);
    registerStoreModule(_MATERIAL_MODULE, materialModule);
    registerStoreModule(_INSTITUTION_MODULE, institutionModule);
    registerStoreModule(_BRANCH_MODULE, branchModule);
    registerStoreModule(_USER_MODULE, userModule);
  },
  components: {
    DashboardBox,
    MultipleSelectInput
  },
  validations: {
    form: {
      document_number: {
        required
      },
      waybill_date: {
        required
      },
      technician_id: {
        required: requiredIf(function() {
          return !this.form.institution_id
        }),
      },
      branch_id: {
        required: requiredIf(function() {
          return !this.form.technician_id
        }),
      },
      institution_id: {
        required: requiredIf(function() {
          return !this.form.technician_id
        }),
      },
      transaction_type: {
        required
      },
      transactions: {
        $each: {
          material_id: {
            required
          },
          net_amount: {
            required
          },
          unit_id: {
            required
          }
        }
      },
    }
  },
  computed: {
    isAuthorizedToEdit() {
      return (this.isSuperAdmin || this.isOperator)
    },
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    },
    files() {
      return store.getters[_MODULE_NAME + "/" + FILES];
    },
    units() {
      return store.getters[_UNIT_MODULE + "/" + UNIT_ITEMS] || [];
    },
    materials() {
      return store.getters[_MATERIAL_MODULE + "/" + MATERIAL_ITEMS] || [];
    },
    institutions() {
      return store.getters[_INSTITUTION_MODULE + "/" + INSTITUTION_ITEMS] || [];
    },
    branches() {
      return store.getters[_BRANCH_MODULE + "/" + BRANCH_ITEMS] || [];
    },
    technicians() {
      return store.getters[_USER_MODULE + "/" + TECHNICIANS] || [];
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      defaultTransaction: {
        material_id: null,
        net_amount: null,
        unit_id: null,
      },
      transactionTypes: [
        {
          "id": 1,
          "name": this.$t('waybills.entrance'),
        },
        {
          "id": 2,
          "name": this.$t('waybills.out'),
        }
      ],
      form: {
        document_number: null,
        waybill_date: null,
        technician_id: null,
        branch_id: null,
        institution_id: null,
        description: null,
        file: null,
        transaction_type: null,
        transactions: [{
          material_id: null,
          net_amount: null,
          unit_id: null,
        }]
      }
    };
  },
  methods: {
    onMaterialSelect(data, index) {
      this.form.transactions[index].net_amount = Number(data.amount);
      this.form.transactions[index].max_amount = Number(data.amount);
      this.form.transactions[index].unit_id = data.unit;
    },
    addTransaction() {
      this.form.transactions.push(this.defaultTransaction);
    },
    uploadFile(e) {
      let file = e.target.files[0];
      this.form.file = file;
      if (this.id && file) {
        let self = this;
        let form = new FormData();
        form.append('file', file);
        let url = BASE_URL + '/' + this.id + '/file';
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPLOAD_FILE, {
              url: url,
              contents: form,
            }).then((response) => {
          if (response.status) {
            setTimeout(() => {
              self.sweetAlertSuccess(response.data.message).then(() => {
                self.$store.dispatch(_MODULE_NAME + "/" + GET_FILES, {
                  url: url
                })
              }) ;
            }, 200);
          }
        });
      }
    },
    deleteFile() {
      let self = this;
      this.sweetAlertConfirm(
          this.$t("general.are_you_sure"),
          function (self) {
            let url = BASE_URL + "/" + self.id + '/file'
            self.$store
                .dispatch(_MODULE_NAME + "/" + DELETE_FILE, {
                  url: url
                }).then(response => {
              if (response.status) {
                self.form.exits_file = null;
                setTimeout(() => {
                  self.sweetAlertSuccess(response.data.message).then(() => {
                    self.$store.dispatch(_MODULE_NAME + "/" + GET_FILES, {
                      url: url
                    })
                  }) ;
                }, 100);
              }
            })
          });
    },
    goBack() {
      this.$router.push({name: "store.waybills"})
    },
    validateState(name, index) {
      if (!(_.isNull(index) || _.isUndefined(index))) {
        const {$dirty, $error} = this.$v.form.transactions.$each[index][name]
        return $dirty ? !$error : null;
      } else {
        const {$dirty, $error} = this.$v.form[name];
        return $dirty ? !$error : null;
      }
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    getUnits() {
        this.$store
            .dispatch(_UNIT_MODULE + "/" + GET_UNIT_ITEMS, {})
    },
    getMaterials() {
      let filter = {
        in_stock: true
      }
        this.$store
            .dispatch(_MATERIAL_MODULE + "/" + GET_MATERIAL_ITEMS, {
              filter: filter
            })
    },
    getInstitutions() {
        this.$store
            .dispatch(_INSTITUTION_MODULE + "/" + GET_INSTITUTION_ITEMS, {})
    },
    getBranches() {
      let filter = {
        institution_id: this.form.institution_id.id
      }

      this.$store
          .dispatch(_BRANCH_MODULE + "/" + GET_BRANCH_ITEMS, {
            filter: filter
          })
    },
    getTechnicians() {
      this.$store
          .dispatch(_USER_MODULE + "/" + GET_TECHNICIANS, {})
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      let formData = _.clone(this.form);

      if (this.id) {
        let formData = _.clone(this.form);

        formData.transactions.forEach(item => {
          item.unit_id = item.unit_id.id
          item.material_id = item.material_id.id
        })

        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        let form = new FormData();
        form.append('document_number', this.form.document_number);
        form.append('waybill_date', this.form.waybill_date);

        if (this.form.branch_id) {
          form.append('branch_id', this.form.branch_id.id);
        }

        if (this.form.technician_id) {
          form.append('technician_id', this.form.technician_id.id);
        }

        if (this.form.institution_id) {
          form.append('institution_id', this.form.institution_id.id);
        }

        form.append('description', this.form.description);
        form.append('transaction_type', this.form.transaction_type.id);

        formData.transactions.forEach((item, index) => {
          form.append('transactions['+index+'][material_id]', item.material_id.id);
          form.append('transactions['+index+'][unit_id]', item.unit_id.id);
          form.append('transactions['+index+'][net_amount]', item.net_amount);
        })

        if(this.form.file !== null) {
          form.append('file', this.form.file);
        }

        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: form,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "waybills.edit_item" : "waybills.create_item")}
    ]);

    if (this.units && !this.units.length) {
      this.getUnits();
    }

    this.getMaterials();

    if (this.institutions && !this.institutions.length) {
      this.getInstitutions();
    }

    if (this.branches && !this.branches.length && this.form.institution_id) {
      this.getBranches();
    }

    if (this.technicians && !this.technicians.length) {
      this.getTechnicians();
    }

    if (this.id) {
      this.getItem();
    }
  },
  watch: {
    'form.institution_id': {
      handler: function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined) return;
        this.form.technician_id = null;
        this.getBranches();
      }
    },
    'form.branch_id': {
      handler: function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined) return;
        this.form.technician_id = null;
      }
    },
    'form.technician_id': {
      handler: function (newValue, oldValue) {
        if (newValue === undefined || oldValue === undefined) return;
        this.form.institution_id = null;
        this.form.branch_id = null;
      }
    },
    files: {
      handler: function (newVal, oldVal) {
        if (newVal) {
          this.form.exits_file = null;
          this.form.exits_file = newVal;
          this.form.image = null;
        }
      },
      deep: true
    },
    item(value) {
      if (value) {
        let item = value.item;

        if (item.image_link) {
          item.image = null;
          item.exits_file = item.image_link;
        }

        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self.sweetAlertSuccess(self.$t("general.successfully_saved"),
              (response) => {
                if (response) {
                  self.$router.push({name: "store.waybills"});
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
